import { Component } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

@Component({
	selector: 'modal-replace-labour',
	templateUrl: './modal-replace-labour.component.html'
})
export class ModalReplaceLabourComponent extends UIModalBaseComponent {

	id;
	description;
	productCount = 0;
	replacements = [];
	replacementId = null;
	action = 'replace';
	disabled = false;

	constructor(
		public app: AppService,
		private api: ApiService,
	) {
		super();
	}

	open(mdata: any) {
		this.id = mdata.id;
		this.description = mdata.description || '';
		this.productCount = mdata.productCount || 0;
		this.replacements = [];
		this.replacementId = null;
		this.action = 'replace';
		this.disabled = false;

		this.api.product.listLabourTypes(data => {
			this.replacements = (data.types || []).filter(t => t.id !== this.id);
			if (!this.replacements.length) this.action = 'delete';
			this.modal.open();
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	get selectedReplacement() {
		return this.replacements.find(t => t.id === this.replacementId) || null;
	}

	submit() {
		if (this.disabled) return;

		const payload: any = { id: this.id };
		if (this.action === 'replace') {
			if (!this.replacementId) return;
			payload.replacement_id = this.replacementId;
		}

		this.disabled = true;
		this.api.product.archiveLabourType(payload, () => {
			this.disabled = false;
			this.app.notifications.showSuccess('Labour type deleted.');
			this.modal.close('deleted');
		}, error => {
			this.disabled = false;
			this.app.notifications.showDanger(error.message);
		});
	}
}
